import React, { Component } from 'react';
import { MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBCardBody, MDBIcon, MDBRow, MDBCol } from 'mdbreact';


class RecruitWithKitCard extends Component {
    constructor(props) {
        super(props);
    }



    render() {
        return (
            <div>

                <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                    <MDBCardTitle style={{ fontSize: "16px" }}>&nbsp;<MDBIcon icon="user" />&nbsp;&nbsp;{this.props.firstNames}&nbsp;{this.props.surname}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;Unit Recruited Into:&nbsp;{this.props.unitName}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;Code:&nbsp;{this.props.sfCurrentCode}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;Start Week:&nbsp;{this.props.startWeekId}</MDBCardTitle>
                    <hr />
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;Week Kit Purchased:&nbsp;{this.props.kitWeekId}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;Date Kit Purchased:&nbsp;{this.props.kitSaleDate}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;Kit Description:&nbsp;{this.props.invoiceDescription}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;Kit Processing Code:&nbsp;{this.props.processingCode}</MDBCardTitle>
                    <hr />
                    
                </MDBCard>

            </div>
        )
    }
}

export default RecruitWithKitCard;